module.exports = __webpack_public_path__ + "img/file_upload_black.a8b88d95.svg";